import {Outlet} from "react-router-dom";
import {ListProvider} from "../provider";

/**
 * High Order Component that stores filter and project list
 * @returns
 */
const EntityManagePage = () => {
    return (
        <ListProvider>
            <Outlet />
        </ListProvider>
    );
};

export default EntityManagePage;
